import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tiles, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';

import Header from '../../../components/Header.js';
import Standard from './Standard/index.js';
import permissionLevel from '../../../services/permissions.js';

class AdjudicationCreateClaim extends PureComponent {
    state = {
        selectedType: null
    };

    static getDerivedStateFromProps(props) {
        if (props.accessType && !permissionLevel('Adjudication', props.accessType).includes('write')) {
            window.location.href = '/403';
        }

        return null;
    }

    _setType = (type) => {
        this.setState({
            selectedType: type
        });
    };

    render() {
        return (
            <ContainerControlSite background={"true"}>
                <Header
                    subHeader="Create Claim"
                    breadcrumbs={[{
                        title: 'Adjudication',
                        link: `/adjudication`
                    }]}
                    selectedTitle="adjudication"
                />

                <Content>
                    <Tiles tiles={[
                        {
                            title: 'Standard',
                            description: 'Submit a standard claim for member',
                            isSelected: this.state.selectedType === 'Standard',
                            onClick: () => this._setType('Standard'),
                            icon: 'Create Claim'
                        },
                        {
                            title: 'HSA',
                            description: 'Submit a Health Spending Claim',
                            isSelected: this.state.selectedType === 'Health Spending',
                            onClick: () => this._setType('Health Spending'),
                            icon: 'Create Claim'
                        },
                        {
                            title: 'LSA',
                            description: 'Submit a Lifestyle Spending Claim',
                            isSelected: this.state.selectedType === 'Lifestyle Spending',
                            onClick: () => this._setType('Lifestyle Spending'),
                            icon: 'Create Claim'
                        }
                    ]}/>

                    {
                        [ 'Standard', 'Lifestyle Spending', 'Health Spending' ].includes(this.state.selectedType) &&
                            <Standard type={ this.state.selectedType } close={ () => this._setType(null) } />
                    }
                </Content>
            </ContainerControlSite>
        );
    }
}

AdjudicationCreateClaim.propTypes = {
    master: PropTypes.object,
    accessType: PropTypes.string
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    master: state.master,
    accessType: state.master.access
});

export default connect(mapStateToProps)(AdjudicationCreateClaim);